import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { Ng2Webstorage } from 'ngx-webstorage'
import { RequestOptions, Http, XHRBackend, HttpModule } from '@angular/http'

import { routing } from '@pages/pages.routing'
import { AppTranslationModule } from '../app.translation.module'

import { Pages } from '@pages/pages.component'
import { Dashboard } from '@pages/dashboard/dashboard.component'
import { DashBoardComponent } from '@components/dashboard/admin/dashboard.component'
import { UtilsModule } from '@shared/utils/utils.module'

@NgModule({
  imports: [
    CommonModule,
    AppTranslationModule,
    UtilsModule,
    Ng2Webstorage.forRoot(),
    routing,
  ],
  declarations: [Pages, Dashboard, DashBoardComponent],
  providers: [

  ],
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts